import { Market, MarketCategory, MarketType } from '../types';

// `line` and `team_id` vary inside one accordion, the rest (e.g. `half`) splits accordions that share a code
const getCategoryKey = ({ code, params }: MarketType) => {
    const { line: _line, team_id: _teamId, ...rest } = params;
    return `${code}-${JSON.stringify(rest)}`;
};

// Only adds lines to categories REST already returned - the socket also carries markets REST hides (e.g. *_EXC_OT).
export const upsertMarketCategories = (categories: MarketCategory[], markets: Market[]) => {
    const knownIds = new Set(categories.flatMap(category => category.markets.map(market => market.id)));
    let next = categories;
    markets.forEach(market => {
        if (knownIds.has(market.id)) {
            return;
        }
        const key = getCategoryKey(market.market_type);
        const index = next.findIndex(category => getCategoryKey(category.market_type) === key);
        if (index === -1) {
            return;
        }
        if (next === categories) {
            next = [...categories];
        }
        next[index] = { ...next[index], markets: [...next[index].markets, market] };
        knownIds.add(market.id);
    });
    return next;
};
